import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import { BasicSelect} from 'vue-search-select';
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import download from 'downloadjs';
import { data } from 'jquery';
import moment from 'moment';

export default {
	name: 'SectorMappingComponent',
	components: {
		BasicSelect,
		VueElementLoading,
		Multiselect,
		Paginate,
		download
	},
	data: function() {
		return {
			hub: '',
			hublist: [],
			hubzonelist: [],
			hubzoneitem: {
				id: '',
				text: ''
			},
			hubzone: '',
			shippingid:"",
			currenthubid:"",
			currenthubname:"",
			createdBy:"",
			SectorListData:[],
			isLoading :false,
			isLoadingUpload:false,
			destinationHubCenterList :[],
			destinationCenterHubId:"",
			destinationCenter:"",
			destinationHubItem: {
				hubid: '',
				hubname: ''
			},
			hubZone:"",
			hubzoneerror:"",
			destinationCentererror:"",
			modalShow:false,
			pageCount:"",
			bagCheckNeeded:false,
			bagType:"",
			bagTypeData: [],
			bagTypeObjData: {
				id: '',
				text: ''
			},

			MotList: [
				{
				value: '1',
				text: "Air"
			   },
		       {
				value : '2',
				text: 'Surface'
			   },

		    ],
			MotListItem: {
				value: "",
				text: ""
			},
			Mot:"",

			businessTypeList: [
				{
				value: '1',
				text: "Ecom"
			   },
		       {
				value : '2',
				text: 'Cargo'
			   },

		    ],
			businessTypeItemList: {
				value: "",
				text: ""
			},

			businessType:"",

			bagCenterItem: {
				hubid: '',
				hubname: ''

			},

			bagCenter:'',
			secondarySector:'',
			primarySector:'',

			businessTypeListFilter:[
				{
				value: '1',
				text: "Ecom"
			   },
		       {
				value : '2',
				text: 'Cargo'
			   },

		    ],
			businessTypeItemFilter:{
				id: '',
				text:''
			},
			businessTypeFilter:'',

			hubzonelistflt:[],
			hubzoneitemflt:{
				id: '',
				text: ''
			},
			hubzoneflt:'',

			bagTypefltList:[],

			bagTypefltitem:{
				id: '',
				text: ''

			},
			bagTypeflt:'',

			motfltlist:[
				{
				value: '1',
				text: "Air"
			   },
		       {
				value : '2',
				text: 'Surface'
			   },

		    ],

			motfltitem:{
				id: '',
				text: ''


			},
			motflt:'',
			sectorData:[],
			groupList:[],
			groupListItem:{
				id: '',
				name:'',
				groupidname: ''
			},
			groupName:'',
			groupId :'',
			sectorData :[],
			pageno: 0,
			pageCount: 0,
			totalRows: 0,
			limit: 10,
			hubzoneLoading:'',
			customZone:'',
			hubErr :'',
			HubId :'',
			HubName:'',
			bagCenterId :'',
			group:'',
			routingCluster:'',
			failed: [],
            isLoading: false,
            createdby:'',
            configFile:'',
			modalUploadShow: false,
			selectedFile:'',
			hubRequired:false,
			failedfile:'',
			hubLoading:'',
			groupLoading:'',
			bagInCheck: {
				hubid: '',
				hubname: '',
				hubidname:''
				},
			BagCenterId : '',
			BagCenterName :'',
			modalEditShow:false	,
			isupdateFlag:false,
			multiBagCenter:{},	
			hublistfinal:[],
			isLoadingHub : false,
			dt:{},
			isLoadingBag :false,
			showGroupBagTypeFlag:false,
			destinationHubFlt:'',
			destinationhublistitem: {
				hubid: '',
				hubname: '',
				hubidname:''

			  },
			destinationHubListFlt:[],
			hubdestination:'',
			hubListForAllocatedUser:[],
			hublistitemforUser: {
				value:'',
				text:''
			}
			
			
		}
	},
	created: function() {},
	computed: {
		
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail[0].userid;
		this.createdBy = userdetail[0].email;
		this.currenthubid  = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0];
		this.getHubList();
		this.getHubListForAllocatedUser();
		//this.getGroupList();
		
	},
	methods: {

		selectHub(hubAllocateditem) {
			this.resetForm();
			this.hublistitemforUser = hubAllocateditem;
			this.HubId = this.hublistitemforUser.value;
			this.HubName = this.hublistitemforUser.text;
			this.hubRequired = true;


		},

		selectDestinationHubFlt(DestinationHubitem){
			this.destinationhublistitem = DestinationHubitem;
			this.destinationHubFlt = this.destinationhublistitem.hubid;
		},

		selectedbagTypeflt(obj){
			this.bagTypefltitem = obj;
			this.bagTypeflt = this.bagTypefltitem.text;

		  },

		selectedBagType(obj) {
			this.bagTypeObjData = obj;
			this.bagType = this.bagTypeObjData.text;

		  },

		selectMot(MotData){
			this.MotListItem = MotData;
            this.Mot = this.MotListItem.text;
        },

		selectedMOTflt(MotData){
			this.motfltitem = MotData;
			this.motflt = this.motfltitem.text;

		},

		selectBusinessType(businessTypeData){
			this.businessTypeItemList= businessTypeData;
			this.businessType = this.businessTypeItemList.text;
			if(this.businessType === "Ecom"){
                this.showGroupBagTypeFlag = true;
			}else{
				this.showGroupBagTypeFlag = false;
			}

		},

		selectedBusinessTypeFilter(businessTypeData){
			this.businessTypeItemFilter = businessTypeData;
			this.businessTypeFilter = this.businessTypeItemFilter.text;

		},

		onSubmitflt: function() {
		
		   this.sectorData =[];
		   this.getSectorList(this.HubId);
		},


		selectHubZoneFlt(hubZoneData){
			this.hubzoneitemflt = hubZoneData,
			this.hubzoneflt = this.hubzoneitemflt.text

		},

		selectBagInCheck(bagCenterItem){
			
			this.bagInCheck = bagCenterItem;
			this.BagCenterId = this.bagInCheck.hubid;
			this.BagCenterName = this.bagInCheck.hubname;
			

		},

		selectedGroup(groupItem){
			this.groupListItem = groupItem;
			this.groupName = this.groupListItem.name;
			this.groupId = this.groupListItem.id;
		},

		SelectedBagCenter(bagCenterData){
			this.bagCenterItem = bagCenterData;
			this.bagCenter = this.bagCenterItem.text;
			this.bagCenterId = this.bagCenterItem.value;
		},


		changeAction($event){
			if($event.target.value == "type1"){
				this.openModal();

			}

			if($event.target.value == "type2"){
				this.openUpdateModal();

			}

			if($event.target.value == "type3"){
				this.exportData();

			}

		},


		getHubListForAllocatedUser() {
			this.isLoadingHub = true;
			this.hub ='';
			this.hubListForAllocatedUser =[];
			this.hublistitemforUser ={};
			this.input = ({
			  userid: this.userid,
			  currenthubid: this.currenthubid 
			})
			axios({
				'method': 'POST',
				'url': apiUrl.api_url_hubops + 'getAllocatedHubsForUser',
				'data': this.input,
				'headers': {
				  'authorization': 'authkey xB84JJ89Hd25',
				}
			  })
			  .then(result => {
				this.isLoadingHub= false;
				if (result.data.ResultCode == 100) {
				  const hubListAllocated = result.data.ResponseData
				  for (var i = 0; i < hubListAllocated .length; i++) {
					this.hubListForAllocatedUser.push({
					  value: hubListAllocated [i].HubID,
					  text: hubListAllocated[i].HubName + ' (' + hubListAllocated[i].HubID + ')',
					})
				  }
				} else {
				  this.$alertify.error(result.data.ReturnMessage)
				}
			  }, error => {
				this.isLoadingHub = false;
				console.error(error)
			  })
		  },

		exportData() {
			this.exportsectordata =[];
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'getLHSectorList?controllingHubId='+this.HubId+
				 (this.hubzoneflt? "&Zone=" + this.hubzoneflt: '' ) + (this.destinationHubFlt? "&destinationHubId=" + this.destinationHubFlt: '' )+(this.businessTypeFilter? "&Business_Type=" + this.businessTypeFilter: '' ) +(this.bagTypeflt? "&Bag_Type=" + this.bagTypeflt: '')+(this.motflt? "&MOT=" + this.motflt: ''),
				headers: {
			  		'authorization': "authkey xB84JJ89Hd25",
			  		'requestfrom': "WEB",
				}
		  	})
		  	.then(result => {
				this.isLoading = false;
				if (result.data.ResultCode == 100) {
					this.exportsectordata  = result.data.ResponseData.map(row => ({ 
						Destination:row.destinationhubname, Zone:row.zone, 'Custom Zone':row.customzone ,
						'Business Type': row.businesstype, Mot:row.mot ,'Bag Type' :row.bagtype,
						Group:row.groupno, 'Group Name':row.groupname,
						'Controlling Hub':row.controllinghubname,'Bag Origin Check Needed':
					row.bagorigincheckneeded == true ?"Yes":"", 'Bag Origin Check Center':row.bagorigincheckcentername,
					'Routing Cluster':row.routingcluster ,'Primary Sector':row.primarysectorname ,
					'Secondary Sector':row.secondarysectorname}));

					this.csvFields = {
						'Destination':'Destination',
						'Zone':'Zone',
						'Custom Zone': 'Custom Zone',
						'Business Type': 'Business Type',
						'Mot': 'Mot',
						'Bag Type': 'Bag Type',
						'Group': 'Group',
						'Group Name': 'Group Name',
						'Controlling Hub': 'Controlling Hub',
						'Bag Origin Check Needed': 'Bag Origin Check Needed',
						'Bag Origin Check Center':'Bag Origin Check Center',
						'Routing Cluster':'Routing Cluster',
						'Primary Sector':'Primary Sector',
						'Secondary Sector':'Secondary Sector',
					  }
		   
					  this.jsonToCSV('SectorDataReport_', this.exportsectordata, this.csvFields);
					  document.getElementById("rack").value= "type0";
					
					
				}
				else {
			  	this.$alertify.error(result.data.ReturnMessage)
				}

		  	}, error => {
				this.isLoading = false;
				console.error(error);
				
		 	})
		
		  },

		  jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
			var csvData = ''
			//Header
			if (this.title != null) {
			  csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			for (let key in data[0]) {
			  if (skipFilter.indexOf(key) == -1)
				csvData += csvfield[key] + ','
			}
			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			//Data
			data.map(function(item) {
			  for (let key in item) {
				if (skipFilter.indexOf(key) == -1) {
				  var escapedCSV = item[key] + '' // cast Numbers to string
				  if (escapedCSV.match(/[,"\n]/)) {
					escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
				  }
				  if (escapedCSV == 'null')
					csvData += ',';
				  else {
					if (dateFilder.indexOf(key) != -1)
					  csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
					else
					  csvData += escapedCSV + ','
				  }
				}
			  }
			  csvData = csvData.slice(0, csvData.length - 1)
			  csvData += '\r\n'
			})
			//Footer
			if (this.footer != null) {
			  csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}
			filename += moment().format('DD-MM-YYYY') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData
		  },
	   
		  export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		  },
	   
		  base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
			  u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
			  type: mime
			})
		  },

		openModal() {
			this.modalShow = true;

		  },

		  closeModal() {
		
			this.modalShow = false;
			
			document.getElementById("rack").value= "type0";

		  },

		getHubList() {
			this.destinationHubListFlt=[];
			this.hublist = [];
			this.isLoadingHub = true;

			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoadingHub = false;
					if (result.data.ResultCode == 100) {
						for (let i = 0; i < result.data.ResponseData.length; i++) {
							this.hublist.push({
							 	hubname:  result.data.ResponseData[i].HubName ,
							 	hubid:result.data.ResponseData[i].HubID,
							 	hubidname:result.data.ResponseData[i].HubName + '(' + result.data.ResponseData[i].HubID + ')'
							});
						this.destinationHubListFlt = this.hublist;
            }

			    	this.getHubZone();
					this.loadBagTypes();

					}
				}, error => {
					this.isLoadingHub = false;
					console.error(error)

				})
		},

		getHubZone() {
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.input = ({
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.isLoading = false;

					this.HubZoneListData = result.data.ResponseData;
					for (i = 0; i < this.HubZoneListData.length; i++) {
						this.hubzonelist.push({
							id: this.HubZoneListData[i].hubzoneid,
							text: this.HubZoneListData[i].hubzonename
						})
					}
					this.hubzonelistflt=this.hubzonelist;

				}, error => {
					this.isLoading = false;
					console.error(error);
				})
		},

		selectHubZone(hubzoneitem) {
			
			this.hubzoneitem = hubzoneitem;
			this.hubzone = this.hubzoneitem.text;
			this.hubzoneid = this.hubzoneitem.id;

			if (this.hubzoneid != undefined) {
				this.getHubName(this.hubzoneid);
			}
		},

		selectDestinationCenter(destinationHubItem){
			this.destinationHubItem = destinationHubItem;
			this.destinationCenter = this.destinationHubItem.text;
			this.destinationCenterHubId = this.destinationHubItem.value;
			
			this.getfetchGroupsMappedToDestinationHub();
		},

		bagCheck(){
			
			
		},

		onSubmit: function() {
			this.$validator.validateAll('hubArea')
			  .then((result) => {
				this.hubErr = ''
				if (!result) {
				  return false;
				} else {
					if (this.hub == '') {
						this.hubErr = 'Hub is required';
					  }
					  else{
						this.getSectorList(this.HubId);

					  }

				  
				}
			  }).catch(() => {
				console.log('errors exist', this.errors);
			  });
		  },
		  

		  getSectorList(controllingHub){
			this.isLoading = true;
			this.sectorData = [];
			this.failedfile = '';
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'getLHSectorList?controllingHubId='+controllingHub + (this.pageno?'&offset=' +this.pageno: '')+ (this.limit?'&limit='+this.limit:'')+
				 (this.hubzoneflt? "&Zone=" + this.hubzoneflt: '' ) +(this.destinationHubFlt? "&destinationHubId=" + this.destinationHubFlt: '' )+ (this.businessTypeFilter? "&Business_Type=" + this.businessTypeFilter: '' ) +(this.bagTypeflt? "&Bag_Type=" + this.bagTypeflt: '')+(this.motflt? "&MOT=" + this.motflt: ''),
				headers: {
			  		'authorization': "authkey xB84JJ89Hd25",
			  		'requestfrom': "WEB",
				}
		  	})
		  	.then(result => {
				this.isLoading = false;
				if (result.data.ResultCode == 100) {
					this.sectorData = result.data.ResponseData;
					this.sectorData.map(v => {v.isEditFlag = false });
					this.totalRows = result.data.totalCount;
							
					if (this.totalRows < this.limit) {
						this.pageCount = 1
					} else {
						this.pageCount = Math.ceil(this.totalRows / this.limit);
					}
					
				}
				else {
			  	this.$alertify.error(result.data.ReturnMessage)
				}

				this.failedfile = result.data.failedPath;
		  	}, error => {
				console.error(error)
				this.isLoading = false
		 	})

		  },

		  onDownload(){
			location.href= this.failedfile;
			
		  },

		//   getGroupList() {
		// 	this.groupLoading = 'Loading Group...'
		// 	axios({
		// 			method: 'GET',
		// 			url: apiUrl.api_url_hubops + 'getAllGroups',
		// 			headers: {
		// 				'Authorization': 'authkey xB84JJ89Hd25'
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.groupLoading = ''
		// 			if (result.data.ResultCode == 100) {
		// 				const GroupDetails = result.data.ResponseData
		// 				for (var i = 0; i < GroupDetails.length; i++) {
		// 					this.groupList.push({
		// 						"id": GroupDetails[i].groupid,
		// 						"name": GroupDetails[i].groupname,
		// 					})
		// 				}
		// 			} else {

		// 				this.$alertify.error(result.data.ReturnMessage);
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 			this.groupLoading = ''
		// 		})
		// },

		getHubName(hubZoneId) {
			var i = 0;
			this.hubLoading = 'Loading Hub...'
			this.destinationHubCenterList = [];
			this.destinationHubItem = {};
			this.bagCenterItem = {};
			this.groupList = [];
			this.group ='';
			this.groupListItem ={};
			this.input = ({
			  hubZoneId: hubZoneId,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list/',
				'data': this.input,
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				}
			  })
			  .then(result => {
				if (result.data.ResultCode == 100) {
				let HubNameData = result.data.ResponseData;
					for (i = 0; i < HubNameData.length; i++) {
					  this.destinationHubCenterList.push({
						value: HubNameData[i].HubID,
						text: HubNameData[i].HubName,
						
					  })
					}
					this.hublistfinal = this.destinationHubCenterList.map((o) => ({
						hubname:  o.text,
						hubid: o.value,
						hubidname: o.text + '(' + o.value + ')'
					}));
					this.hubLoading='';
			  }
			}, error => {
				console.error(error)
				this.hubLoading='';
			  })
		  },

		getfetchGroupsMappedToDestinationHub(){
			this.groupLoading = 'Loading Group...'
			this.groupList = [];
			this.group ='';
			this.groupListItem ={};
			
			axios({
					method: 'GET',
					//url: apiUrl.api_url_hubops + 'fetchGroupsMappedToDestinationHub?'+ 'destinationHubId='+ this.destinationCenterHubId ,
					url: apiUrl.api_url_hubops + 'groups/by-destination-hub?destinationHubId=' + this.destinationCenterHubId + '&profile=summary',
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.groupLoading = ''
					if (result.data.ResultCode == 100) {
						const GroupDetails = result.data.ResponseData
						for (var i = 0; i < GroupDetails.length; i++) {
							this.groupList.push({
								"id": GroupDetails[i].groupno,
								"name": GroupDetails[i].groupname,
								"groupidname": GroupDetails[i].groupname + "(" + GroupDetails[i].groupno + ")"
							})
						}
					} else {

						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					console.error(error)
					this.groupLoading = ''
				})

		},


		  getPaginationData(pageNum) {
			this.pageno = (pageNum - 1);
			this.getSectorList(this.HubId);

		  },

		selectDestination(){},

		loadBagTypes() {
			this.isLoading = true;
			this.bagTypeData =[];
			this.bagTypefltList = [];
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'fetchBagTypes' + "?hubId=" + this.currenthubid ,
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				  'requestfrom': "WEB",
				}
			  })
			  .then(result => {
				this.isLoading = false;
				if (result.data.ResultCode == 100) {
				  this.invalidTokenModal = false
				  var bagTypeData = result.data.ResponseData
				  for (var i = 0; i < bagTypeData.bagType.length; i++) {
					this.bagTypeData.push({
					  text: bagTypeData.bagType[i].bagtype
					})
					this.bagTypefltList.push({
						text: bagTypeData.bagType[i].bagtype
					  })
				  }


				} else{
				  this.$alertify.error(result.data.ReturnMessage)
				}
			  }, error => {
				this.isLoading = false;
				console.error(error)
			  })
		  },

		  AddSectorRow(){
			this.input = ({
				 controllingHubId: Number(this.HubId),
				 controllingHubName:this.HubName,
				 Primary_Sector: this.primarySector,
				 Secondary_Sector: this.secondarySector,
				 destinationHubId: Number(this.destinationCenterHubId),
				 Destination: this.destinationCenter,
				 Group_No: String(this.groupId),
				 GroupName: this.groupName,
				 Zone: this.hubzone,
				 Custom_Zone: this.customZone,
				 Business_Type: this.businessType,
				 Bag_Type: this.bagType,
				 MOT: this.Mot,
				 Bag_Origin_Check_Needed: this.bagCheckNeeded?this.bagCheckNeeded:false,
				 Bag_Origin_Check_Center_Id:Number(this.bagCenterId),
				 Bag_Origin_Check_Center_Name: this.bagCenter,
				 Routing_Cluster: this.routingCluster,
				 lastModifiedBy: this.createdBy
			})

			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + 'addLHSector',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoadingBag  = false;
				let response = result.data;
				if (response.ResultCode == 100 ) {
					this.$alertify.success(result.data.ReturnMessage);
					this.closeModal();
					this.getSectorList(this.HubId);
					this.resetAddRow();

				}else{
					this.$alertify.error(result.data.ReturnMessage)
				}
			}, error => {

				console.error(error);
				this.isLoadingBag = false;
			})
		  },

		  EditRow(Sectorid){


			let tt = this.sectorData.map(row =>
				row.sectorid === Sectorid ? Object.assign(row, {isEditFlag : true}) :Object.assign(row, {isEditFlag : false})
			);
			this.dt = Object.assign({}, this.sectorData.find(o => o.sectorid === Sectorid));
			const zoneName = this.dt.zone;
			if(zoneName){
				let zoneData = this.hubzonelist.find(o => o.text=== zoneName);
				const ZoneDataId = zoneData.id;
				this.getHubName(ZoneDataId);
			}else{
				this.hublistfinal	= this.hublist;
			}
			this.multiBagCenter = this.hublist.find(option => option.hubid === this.dt.bagorigincheckcenterid);
			this.sectorData = [...tt];
		},

		updateRow(){
			    const sectorId = this.modaldata.sectorid;

				const data = this.sectorData.find(row => row.sectorid == sectorId);
				this.isLoading  = true;

				this.input = ({
					 controllingHubId: data.controllinghubid,
					 SectorId:data.sectorid,
					 Primary_Sector: data.primarysectorname,
					 Secondary_Sector: data.secondarysectorname,
					 destinationHubId: data.destinationhubid,
					 Group_No: data.groupno,
					 Custom_Zone: data.customzone,
					 Business_Type: data.businesstype,
					 Bag_Type: data.bagtype,
					 MOT: data.mot,
					 Bag_Origin_Check_Needed: data.bagorigincheckneeded?data.bagorigincheckneeded:false,
					 Bag_Origin_Check_Center_Id:this.multiBagCenter?this.multiBagCenter.hubid:null,
					 Bag_Origin_Check_Center_Name: this.multiBagCenter?this.multiBagCenter.hubname:null,
					 Routing_Cluster: data.routingcluster,
					 status:data.isactive,
					 lastModifiedBy: this.createdBy
				})

				axios({
					method: "POST",
					'url': apiUrl.api_url_hubops + 'updateRemoveLHSector',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				}).then(result => {
					this.isLoading  = false;
					let response = result.data;
					if (response.ResultCode == 100 ) {
						this.$alertify.success(result.data.ReturnMessage);
						this.getSectorList(this.HubId);
						let tt = this.sectorData.map(row =>
							row.sectorid === sectorId ? Object.assign(row, {isEditFlag : false}) : row
						)
						this.sectorData = [...tt];
			
					}else{
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {

					console.error(error);
					this.isLoading = false;
				})
			
		},

	


		deleteRow(){

			const sectorId = this.modaldata.sectorid;

			const data = this.sectorData.find(row => row.sectorid == sectorId);
			this.isLoading = true;

				this.input = ({
					 controllingHubId: data.controllinghubid,
					 SectorId:data.sectorid,
					 Primary_Sector: data.primarysectorname,
					 Secondary_Sector: data.secondarysectorname,
					 destinationHubId: data.destinationhubid,
					 Group_No: data.groupno,
					 Custom_Zone: data.customzone,
					 Business_Type: data.businesstype,
					 Bag_Type: data.bagtype,
					 MOT: data.mot,
					 Bag_Origin_Check_Needed: data.bagorigincheckneeded?data.bagorigincheckneeded:false,
					 Bag_Origin_Check_Center_Id:data.bagorigincheckcenterid,
					 Bag_Origin_Check_Center_Name: data.bagorigincheckcentername,
					 status:false,
					 lastModifiedBy: this.createdBy
				})

				axios({
					method: "POST",
					'url': apiUrl.api_url_hubops + 'updateRemoveLHSector',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				}).then(result => {
					this.isLoading  = false;
					let response = result.data;
					if (response.ResultCode == 100 ) {
						this.$alertify.success(result.data.ReturnMessage);
						this.getSectorList(this.HubId);
					}else{
						this.$alertify.error(result.data.ReturnMessage)

					}
					
				}, error => {

					console.error(error);
					this.isLoading = false;
				})
		},


		cancelRow(sectorId ){
			
			let tt = this.sectorData.map(row =>
				row.sectorid === sectorId ? Object.assign(row, {isEditFlag : false, routingcluster:this.dt.routingcluster,
					customzone:
					this.dt.customzone , bagorigincheckneeded :this.dt.bagorigincheckneeded,
					primarysectorname:this.dt.primarysectorname,secondarysectorname:this.dt.secondarysectorname}) : row
			)
			this.sectorData = [...tt];

		},


		onAddSubmit:function(Add){
			this.$validator.validateAll('Add')
			  .then((result) => {
				if (!result) {
				  console.log('errors exist', this.errors); 
				  return false;
				}else { 
					this.AddSectorRow();
				}
			  }).catch(() => {
				console.log('errors exist', this.errors);
			  });

		},



		resetAddRow(){
			this.hubzoneitem= {
				id: '',
				text: ''
			},
			this.hubzone ='',
			this.destinationHubItem = {
				hubid: '',
				hubname: ''
			},
			this.destinationCenter='';
			this.customZone ='';
			this.businessTypeItemList= {
				value: "",
				text: ""
			}
			this.businessType= '';
			this.MotListItem ={
				value: "",
				text: ""
			},
			this.Mot= '',
			this.bagTypeObjData ={
				id: '',
				text: ''
			},

			this.bagCenterItem ={
				hubid: '',
				hubname: ''
			},

			this.bagCenter='',
			this.bagType ='',
			this.group ='',
			this.bagCheckNeeded ='',
			this.routingCluster ='',
			this.primarySector ='',
			this.secondarySector ='';
			this.$validator.reset();
			this.isLoadingBag =false;


		},

	



		  uploadConfigFile(event){

			if(!this.HubId|| !this.HubName){
				this.$alertify.error("Error: Logged-In hub should not be empty!"); return false;
			}

			this.failed = [];
			this.isLoadingUpload = true;

      		this.selectedFile = event.target[0].files[0];

			if(this.selectedFile.size>5242880){
				this.isLoadingUpload = false;
        		this.$alertify.error("Failed! Upload Max File Size Should Not Be Greater Than 5 MB"); return false;
      		}else if ( /\.(csv)$/i.test(this.selectedFile.name) ){

        	const fd = new FormData();

      		fd.append('controllingHubId', this.HubId);
	  		fd.append('controllingHubName', this.HubName);
        	fd.append('lastModifiedBy', this.createdBy);
        	fd.append('file', this.selectedFile);

        	axios.post(apiUrl.api_url_hubops + 'uploadSectorConfigFileS3', fd,
        	{
          	headers: {
            	'Authorization': 'authkey xB84JJ89Hd25'
          	}
        	})
        	.then(result => {

          	if(result.data.ResultCode == 100){
            	this.$alertify.success(result.data.ReturnMessage);
          	}else{
				this.$alertify.error(result.data.ReturnMessage);
			}
			this.isLoadingUpload= false;
        	}, error => {
          	console.error(error)
          	this.isLoadingUpload= false;
          	this.$alertify.error('Error Occured');
       		 });
      	}else{
        	this.isLoadingUpload= false;
        	this.$alertify.error("Failed! Please Upload Only Valid Format: .csv");
      }
    },

		  onUploadSubmit: function(res) {
			this.$validator.validateAll('FileUpload').then((result) => {
			  if(result){
				this.uploadConfigFile(event);
				this.closeUpdateModal();
				event.target.reset();
			 }else{
					this.isLoadingUpload = false;
				   }
			}).catch(() => {
			  this.isLoadingUpload = false;
			  this.$alertify.error('Error Occured');
			});
		  },

		  resetUpload(event){
			this.isLoadingUpload = false;
			this.failed = [];
			this.$validator.reset();
			this.errors.clear();
		  },

		  openUpdateModal() {
			this.modalUploadShow = true;

		  },

		  closeUpdateModal(){
			this.modalUploadShow = false;
			document.getElementById("rack").value= "type0";

		  },

		  openEditModal(data, isupdate) {
			this.modaldata = data
			this.isupdateFlag = isupdate
			this.modalEditShow = true
		  },
	  
		  closeEditModal() {
			this.modalEditShow= false
		  },

		  resetFilter(){
			this.destinationHubFlt ='',
			this.destinationhublistitem= {
				hubid: '',
				hubname: '',
				hubidname:''

			  },
			this.hubdestination ='';
			

			this.bagTypefltitem={
				id: '',
				text: ''

			}
			,
			this.motfltitem={
				id: '',
				text: ''


			}
			this.hubzoneitem= {
				id: '',
				text: ''
			},

			this.businessTypeItemFilter={
				id: '',
				text:''
			}

			this.motflt = '';
			this.bagTypeflt = '';
			this.hubzoneflt ='';
			this.businessTypeFilter = '';
			this.sectorData = [];
			this.hubzoneitemflt={
				id: '',
				text: ''
			}
			this.getSectorList(this.HubId);
		  },

		resetForm() {
			this.hub='';
			this.HubId = '';
			this.hubErr ='';
			this.HubName = '';
			this.sectorData = [];
			this.hubzoneflt ='';
			this.businessTypeFilter = '';
			this.motflt = '';
			this.bagTypeflt = '';
			this.hubRequired = false;
			this.isLoading = false;
			this.bagTypefltitem={
				id: '',
				text: ''

			};
			this.motfltitem={
				id: '',
				text: ''
			};
			this.hubzoneitem= {
				id: '',
				text: ''
			};

			this.businessTypeItemFilter={
				id: '',
				text:''
			};
			this.hubzoneitemflt={
				id: '',
				text: ''
			};
			this.failedfile = '';
			this.multiBagCenter = {};
			this.isLoadingHub = false;
			this.isLoadingBag =false;
			this.pageno = 0;
			this.pageCount = 0;
			this.limit= 10;
			this.totalRows = 0;
			this.showGroupBagTypeFlag = false;
			this.destinationHubFlt ='',
			this.destinationhublistitem= {
				hubid: '',
				hubname: '',
				hubidname:''

			  }
			this.hubdestination ='';
			this.hublistitemforUser ={
				value:'',
				text:''
			};
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/SectorMapping/SectorMapping.js